﻿import React from 'react';
import {connect} from 'react-redux';

import {GuideFormBase, connectForm} from './GuideFormBase';
import RadioButton from '../../../Forms/Components/RadioButton';
import CheckBox from '../../../Forms/Components/Checkbox';

import {required} from '../../../Forms/Validation/rules';

class Step4Form extends GuideFormBase {
    render() {
        const StepForm = this.stepFormWrapper; 

        return (
            <StepForm heading="Har du några barn?">
                <RadioButton 
                    layout="inline"
                    theme="big"
                    id="hasChildren__ja"
                    name="hasChildren" 
                    value="ja"
                    displayname="Ja"
                    validations={[required]}
                    data-validation-error-message="Välj en"
                    defaultChecked={this.props.formData.hasChildren === 'ja'}
                />

                <RadioButton 
                    layout="inline"
                    theme="big"
                    id="hasChildren__nej"
                    name="hasChildren" 
                    value="nej"
                    displayname="Nej"
                    validations={[required]}
                    data-validation-error-message="Välj en"
                    defaultChecked={this.props.formData.hasChildren === 'nej'}
                />

                <br/>

                <CheckBox
                    theme="big"
                    layout="inline"
                    type="checkbox"
                    id="willHaveChildren__true"
                    name="willHaveChildren"
                    displayname="Jag har barn på gång"
                    value="true"
                    checked={this.props.formData.willHaveChildren == true}
                />
            </StepForm>
        );
    }
}

export default connectForm({ formClass: Step4Form, guideStep: 4 });